window.options.slickOptions.onlyInitialiseSlickCarouselOnMobile = true;